module.exports = {"id":"3665","name":"Benjamin Nivet","rating":"73","photo":"./data/images/photos/2/3665.png","club":{"name":"ESTAC Troyes","logo":"./data/images/clubs/ESTACTroyes.png"},"positions":["MOC","MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BenjaminNivet0.json
// module id = 575
// module chunks = 0